// extracted by mini-css-extract-plugin
module.exports = {"contactdata":"contactdata_contactdata__2G0mH","Success":"contactdata_Success__3oj5K","detailsinput":"contactdata_detailsinput__2hDyY","request":"contactdata_request__o6SlA"};